import {ViewType} from "../../../../gd/const/views/view-type";
import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";

export const NOTIFICATIONS_CONFIG : ViewPersonalConfig = {
    type            : ViewType.NOTIFICATIONS,
    name            : 'Notifications',
    icon            : 'i5-notification',
    iconSvg         : '',
    url             : 'notifications',
    description     : '',
    defaultLocation : PersonalViewLocation.HOME
}
